import CryptoJS from "crypto-js";

function base64url(source: string) {
  let encodedSource = CryptoJS.enc.Base64.stringify(source as any);
  encodedSource = encodedSource.replace(/=+$/, "");
  encodedSource = encodedSource.replace(/\+/g, "-");
  encodedSource = encodedSource.replace(/\//g, "_");
  return encodedSource;
}

function jwtSign(payload: any, secretOrPrivateKey: string) {
  const header = { alg: "HS256", typ: "JWT" };
  const stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
  const encodedHeader = base64url(stringifiedHeader as any);
  const stringifiedPayload = CryptoJS.enc.Utf8.parse(JSON.stringify(payload));
  const encodedPayload = base64url(stringifiedPayload as any);
  const encodedSignature = base64url(
    CryptoJS.HmacSHA256(
      encodedHeader + "." + encodedPayload,
      secretOrPrivateKey
    ) as any
  );

  return encodedHeader + "." + encodedPayload + "." + encodedSignature;
}

export default (
  location: Location,
  connectToken?: string,
  customerToken?: string
) => {
  const payload: any = {
    location,
  };

  if (connectToken) {
    payload.connect = connectToken;
  }

  if (customerToken) {
    payload.customer = customerToken;
  }

  const jwt = jwtSign(payload, "client");

  return jwt;
}
